import { Fragment, ReactNode } from "react";
import { Header } from "../header/header";
import {Footer} from "../Footer/Footer";
export const Container = ({ children }: { children: ReactNode }) => {
  return (
    <Fragment>
      <Header />
      {children}
      <Footer />
    </Fragment>
  );
};
